import { PropsWithChildren } from 'react'

import { Spin } from 'antd'

import { FallbackProps } from './interface'

export const Fallback = ({
  description = '加载中...',
  size = 'large',
  delay = 500,
  indicator,
  children
}: PropsWithChildren<FallbackProps>) => {
  return (
    <Spin
      delay={delay}
      description={description}
      indicator={indicator}
      size={size}
    >
      <div style={{ paddingTop: '300px', textAlign: 'center' }}>{children}</div>
    </Spin>
  )
}
